import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CreateSageHrConfiguration } from '@app/models/integrations/sage-hr/create-sage-hr-configuration.model';
import { SageHrConfiguration } from '@app/models/integrations/sage-hr/sage-hr-configuration.model';
import { UpdateSageHrConfiguration } from '@app/models/integrations/sage-hr/update-sage-hr-configuration';
import { Observable } from 'rxjs';
import { SageHrConfigurationService } from './interfaces/sage-hr-configuration.service';

@Injectable({
  providedIn: 'root'
})
export class SageHrConfigurationApiService implements SageHrConfigurationService {
  private readonly baseUrl = 'api/sage-hr/configuration';
  
  constructor(private readonly http: HttpClient) { }

  getSageHrConfiguration(): Observable<SageHrConfiguration> {
    const url = `${this.baseUrl}`;
    return this.http.get<SageHrConfiguration>(url);
  }

  createSageHrConfiguration(createSageHrConfiguration: CreateSageHrConfiguration): Observable<SageHrConfiguration> {
    const url = `${this.baseUrl}`;
    return this.http.post<SageHrConfiguration>(url, createSageHrConfiguration);
  }

  updateSageHrConfiguration(updateSageHrConfiguration: UpdateSageHrConfiguration): Observable<SageHrConfiguration> {
    const url = `${this.baseUrl}`;
    return this.http.patch<SageHrConfiguration>(url, updateSageHrConfiguration);
  }

  deleteSageHrConfiguration(): Observable<void> {
    const url = `${this.baseUrl}`;
    return this.http.delete<void>(url);
  }
}